<template lang="html">
    <div>
        Criar Album
        <album-form v-model="album" />

        <!-- Buttons -->
        <div>
          <v-btn color="success" large @click="clickCreate()">Guardar</v-btn>
          <v-btn color="" large>Cancelar</v-btn>
        </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import albumForm from '@/components/Album/albumForm'
export default {
  data: function () {
    return {
      album: {
        title: null,
        author: null,
        release_date: null,
        serial: null,
        spotify_widget: null,
        cover_image: null,
        descriptions:[],
        platforms:[],
      }
    }
  },
  methods: {
    ...mapActions([
      'createAlbum'
    ]),
    clickCreate: function () {
      this.createAlbum(this.album).then(() => {
        this.$router.push({ name: 'AlbumList' })
      })
    }
  },
  components:{
    albumForm
  }
}
</script>

<style lang="css" scoped>
</style>
